import { api } from './client';

/** Map Atlas reads (BP-MAP-ATLAS-02). Mirrors the other api/*.js wrappers. */
export async function fetchAtlases() {
  return api.get('/atlases');
}

export async function fetchAtlas(id) {
  return api.get(`/atlases/${id}`);
}

/** Map Atlas writes (BP-MAP-ATLAS-03) — admin only; backend gates via requireAdmin. */

/** Create a new atlas row. Returns the created atlas. */
export async function createAtlas(payload) {
  return api.post('/admin/atlases', payload);
}

/** Partial update; the DB trigger bumps `version`. Returns the saved atlas. */
export async function updateAtlas(id, payload) {
  return api.patch(`/admin/atlases/${id}`, payload);
}

/**
 * Upload an asset to an atlas. The browser reads native dimensions client-side
 * (Image/<video>) and sends them with the file; the backend sharp pipeline
 * validates + optimizes (image → WebP + thumb; video → stored as-is).
 *
 * @param {string} id   atlas id
 * @param {{ file: File, kind: 'image'|'video', width: number, height: number }} p
 * @returns { asset_url, asset_type, native_width, native_height } (ADR-050)
 */
export async function uploadAtlasAsset(id, { file, kind, width, height }) {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('kind', kind);
  fd.append('width', String(width));
  fd.append('height', String(height));
  return api.upload(`/admin/atlases/${id}/upload`, fd);
}
